<template>
  <div>
    <div class="toolbar search-form">
      <el-select filterable v-model="level" placeholder="等级" :clearable="true">
        <el-option
          v-for="item in $store.state.levels"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-input v-model="num" placeholder="课程编号" style="width:200px;" />
      <el-input v-model="search" placeholder="搜索角色" style="width:200px;"/>
      <el-button type="primary" @click="handleBatch">添加角色</el-button>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="id" label="编号" sortable></el-table-column>
      <el-table-column prop="level" label="等级"></el-table-column>
      <el-table-column prop="num" label="课程"></el-table-column>
      <el-table-column label="图像">
        <template v-slot="item">
          <Avatar :src="item.row.avatar"></Avatar>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column prop="pinyin" label="拼音"></el-table-column>
      <el-table-column prop="gender" label="性别"></el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="updateForm(scope.row)" type="text" size="small">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-if="total>pageSize"
    >
    </el-pagination>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%">
      <KewenRoleForm ref="form"></KewenRoleForm>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
    <Sidebar :visible.sync="batchVisible" header="批量添加">
      <KewenRoleForm ref="batchform"></KewenRoleForm>
      <div class="text-right">
        <el-button @click="batchVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBatch">确 定</el-button>
      </div>
    </Sidebar>
  </div>
</template>

<script>
import KewenRoleForm from './KewenRoleForm'
import Avatar from './../Avatar'
import Sidebar from './../Sidebar'

export default {
  data () {
    return {
      level: null,
      num:null,
      search: '',
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      multipleSelection: [],
      dialogTitle: '添加角色',
      dialogVisible: false,
      batchVisible: false
    }
  },
  components: { KewenRoleForm, Avatar, Sidebar },
  created () {
    this.fetchData()
  },
  watch: {
    level () {
      this.fetchData()
    },
    num () {
      this.fetchData()
    },
    search () {
      this.fetchData()
    }
  },
  methods: {
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    fetchData () {
      this.$http.get(this.$urls.kewen_role_list, {
        params: {
          page: this.currentPage,
          'per-page': this.pageSize,
          "filter[level]": this.level === '' ? null : this.level,
          "filter[num]": this.num === '' ? null : this.num,
          "filter[name][like]": this.search || null,
        }
      }).then(res => {
        this.total = Number.parseInt(res.headers['x-pagination-total-count'])
        this.currentPage = Number.parseInt(res.headers['x-pagination-current-page'])
        this.tableData = res.data
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    },
    createForm () {
      this.dialogVisible = true
      this.dialogTitle = '添加角色'
      setTimeout(() => {
        if (this.$refs.form.form.id) {
          this.$refs.form.reset()
        }
      }, 1)
    },
    submitForm () {
      this.$refs.form.submit().then(res => {
        this.dialogVisible = false
        this.fetchData()
        this.$refs.form.reset()
      })
    },
    updateForm (item) {
      this.dialogVisible = true
      this.dialogTitle = '编辑角色'
      setTimeout(() => {
        this.$refs.form.reset(item)
      }, 10)
    },
    handleBatch () {
      this.batchVisible = true;
    },
    submitBatch () {
      this.$refs.batchform.submit().then(() => {
        this.fetchData()
        this.$refs.batchform.reset({level: this.$refs.batchform.form.level})
      })
    }
  }
}
</script>